export default {
  categoryInfo: {
    mainTitle: 'Yabancı Sağlık Sigortası',
    description: {
      title: 'Yabancı (Uyruklu) Sağlık Sigortası Nedir?',
      content: [
        'Yabancı sağlık sigortası Türkiye’de öğrenim gören, iş için bulunan veya her hangi bir sebeple ikamet etmek isteyen yabancılar için yaptırması zorunlu olan sigorta ürünüdür.'
      ]
    },
    subContent: {
      title: 'Yabancı Sağlık Sigortası Ne İşe Yarar?',
      content: [
        {
          paragraph:
            'Yabancı sağlık sigortası, yabancı uyruklu kişilerin Türkiye’de ikamet ettiği sürece karşılaşabileceği sağlık risklerine karşı güvence sağlamaktadır.',
          subList: null
        }
      ]
    }
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Yabancı Sağlık Sigortası Zorunlu Mudur?',
      content: [
        {
          paragraph:
            'Yabancı sağlık sigortası yatarak ve ayakta tedavileri kapsamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Yabancı Sağlık Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph: null,
          subList: [
            'Yatarak tedavi teminatı, anlaşmalı hastanelerde 24 saati aşan tedavileri kapsamaktadır.',
            'Ayakta tedavi teminatı, anlaşmalı hastanelerde 24 saati aşmayan tedavileri kapsamaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Yabancı Sağlık Sigortası Kapsam Dışı Kalan Haller?',
      content: [
        {
          paragraph: null,
          subList: [
            'Sigortalının poliçe başlangıç tarihinden önce var olan şikâyet ve hastalıkları ile ilgili her türlü sağlık harcamaları, sigortalılık dönemi öncesinde uygulanan ameliyat ve tedavilerin nüksetmesi ve komplikasyonları.',
            'Poliçe limiti üstünde kalan tedaviler.',
            'Diş ve göz muayeneleri.',
            'Kısırlık tanı ve tedavi giderleri.',
            'Organ nakil giderleridir.'
          ]
        }
      ]
    },
    {
      title: 'Yabancı Sağlık Sigortası Yaş Sınırı Nedir?',
      content: [
        {
          paragraph:
            'Yabancı sağlık sigortası yaş sınırları şirketler arası farklılık göstermektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Neden Yabancı Uyruklu Sağlık Sigortası Yaptırmalıdır?',
      content: [
        {
          paragraph:
            'Türkiye’de ikamet edebilmek için zorunlu olarak yaptırılması gerekmektedir. Bununla beraber sağlık risklerinizi de güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Yabancı Sağlık Sigortası Anlaşmalı Hastaneler Nedir?',
      content: [
        {
          paragraph:
            'Anlaşmalı hastaneler sigorta şirketleri arasında farklılık göstermektedir. Almış olduğunuz şirkete ait anlaşmalı hastaneleri uzman danışmanlarımızdan öğrenebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Yabancı Uyruklular İçin Sağlık Sigortası’nın Avantajları Nelerdir?',
      content: [
        {
          paragraph:
            'İkametgâh başvuru sırasında yabancı sağlık sigortası bulunması gereken işlemlerin hızlı ve kolay bir şekilde gerçekleşmesine olanak sağlar.',
          subList: [
            '1 veya 2 yıllık olarak düzenlenebilir.',
            'Diyaliz, kemoterapi, veya ilaç masraflarınızı sigortadan karşılayabilirsiniz.',
            'Kritik hastalıklara karşı güvence sağlar.'
          ]
        }
      ]
    },
    {
      title: 'Yabancı Sağlık Sigortası İptal Edilir Mi?',
      content: [
        {
          paragraph:
            'Yabancı sağlık sigortası iptal edilebilmektedir. Yalnız ikametgâh izni iptali veya genel sağlık sigortası kapsamı dâhiline girilmesi gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Yabancı Sağlık Sigortasından Kimler Faydalanabilir?',
      content: [
        {
          paragraph:
            'Sigorta şirketlerinin sunmuş olduğu yaş sınırları arasında yer alan yabancı uyruklu kişiler yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Yabancı Uyrukluyum, Çalışma İzni Alırken Sağlık Sigortası Yaptırmam Gerekiyor Mu?',
      content: [
        {
          paragraph:
            'Kanun gereğince çalışma izni almak için sağlık sigortası yaptırılması gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Doğum ve Gebelik Durumu Yabancı Sağlık Sigortası Kapsamına Giriyor Mu?',
      content: [
        {
          paragraph:
            'Yabancı sağlık sigortası kapsamında doğum ve gebelik teminatı verilmemektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Yabancılar Sağlık Sigortası Nereden Yaptırılır?',
      content: [
        {
          paragraph:
            'Türkiye’ye ikamet edecek misafirlerimiz yabancı sağlık sigortası yaptırması zorunlu tutulmuştur.',
          subList: null
        },
        {
          paragraph:
            'Alokasko olarak sizin bu ihtiyacınızı giderebilmek için uzman ekibimiz ile buradayız. Fiyat teklifi almak için başvuru formunu doldurabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Yabancı Sağlık Sigortasından Çocuğunuz Yararlanabilir Mi?',
      content: [
        {
          paragraph:
            'Yabancı sağlık sigortanızdan çocuğunuz yararlanamamaktadır. Çocuğunuz için yeni bir sigorta satın almanız gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Yabancı Sağlık Sigortası Yurt Dışında Geçerli Mi?',
      content: [
        {
          paragraph:
            'Yabancı sağlık sigortası sadece Türkiye sınırları içerisinde geçerlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Yabancı Sağlık Sigortası İçin Gerekli Evraklar Nelerdir?',
      content: [
        {
          paragraph:
            'Yabancı sağlık sigortası alabilmek için gerekli belgeler;',
          subList: [
            'Sigortalanacak kişinin pasaport bilgileri.',
            'İkamet adresi',
            'Sigortalanacak kişinin baba adıdır.'
          ]
        }
      ]
    },
    {
      title:
        'Yabancı Uyruklu Eşlerin Sağlık Hizmetlerinden Yararlanma Şartları Neler?',
      content: [
        {
          paragraph: null,
          subList: [
            'Eşin SSK, BAĞ-KUR veya Emekli Sandığı gibi kurumlarda güvence altında olması,',
            'Kişinin ikamet teskeresi, yurt dışı ülkelerinden yardım almadığını belirten taahhütte bulunması.',
            'Yabancı uyruklular için verilen TC numarası bulunması gerekmektedir.'
          ]
        }
      ]
    },
    {
      title: 'Eşim Türk Vatandaşı Yabancı Sağlık Sigortası Yaptırmalı Mıyım?',
      content: [
        {
          paragraph:
            'Kanun gereğince eşinizin sosyal güvencesi bulunuyorsa yaptırmanız zorunlu değildir.',
          subList: null
        }
      ]
    },
    {
      title: 'Yabancı Uyruklu Öğrenci Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Öğrenim görmek için Türkiye’ye gelen öğrenciler seyahat sağlık sigortası yaptırması yeterlidir.',
          subList: null
        }
      ]
    },
    // {  BURADA TABLO YAPISI OLACAK DAHA SONRA BAKILACAK
    //   title: 'Yabancı Sağlık Sigortası Yapan Şirketler Hangileri?',
    //   content: [
    //     {
    //       paragraph:
    //         'Devlet destekli alacak sigortası, vadeli satışlardan elde edilen ciro ve vadenin süresine göre hesaplanmaktadır.',
    //       subList: null
    //     }
    //   ]
    // }
    {
      title: 'En İyi Yabancı Sağlık Sigortası Nasıl Alınır?',
      content: [
        {
          paragraph:
            'En iyi yabancı sağlık sigortasını alabilmek için öncelikle teminatlar ve sigorta şirketi hakkında bilgi almanız gerekmektedir. Bu bilgiler her ihtiyacınıza cevap bulabilmenizi sağlamaktadır.              ',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com üzerinden bilgilerinizi girerek yabancı sağlık sigortası alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'En Ucuz Yabancı Sağlık Sigortası Alınır Mı?',
      content: [
        {
          paragraph:
            'Her hangi bir şey alırken genelde en ucuzunu almaya çalışıyoruz. Yalnız en ucuz her zaman en kaliteli olmayabilir. Yabancı sağlık sigortasında fiyattan daha çok teminatlara bakılmalıdır.',
          subList: null
        },
        {
          paragraph:
            'Sigorta teminatları ihtiyaçlarınıza ne kadar cevap verebiliyorsa o poliçe o kadar iyidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Online Yabancı Sağlık Sigortası Almak Avantajlı Mı?',
      content: [
        {
          paragraph:
            'Günümüzde her işimizi hallede bildiğimiz ve Covid- 19 döneminde elimiz ayağımız olan internet sigorta ihtiyacınızı da karşılamanız için olanak sunmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Covid-19 süresi boyunca almanız gereken en önemli tedbirlerde biri olan mesafe kuralını poliçenizi online alarak uygulamış olurusunuz. Hem kendi sağlığınızı hem de karşı tarafın sağlığını koruyarak, zamandan kazanırsınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Yabancı  (Uyruklu) Sağlık Sigortası Fiyatları Ne Kadar?        ',
      content: [
        {
          paragraph:
            'Yabancı sağlık sigortası fiyatları sigortalının boy, kilo, yaş ve istekleri doğrultusunda değişmektedir.              ',
          subList: null
        },
        {
          paragraph:
            'Her sigortalı aday için farklı fiyatlar çıkabilmektedir. Bu bağlamda net bir fiyat söylenememektedir.',
          subList: null
        },
        {
          paragraph:
            'Sizde yabancı sağlık sigortası teklifi almak için alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan teklif talebinde bulanabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Teklif için gerekli bilgilerin iletilmesi halince size özel olarak hazırlanmış teklif en kısa sürede sunulur ve istekleriniz doğrultusunda poliçeniz tanzim edilir.',
          subList: null
        }
      ]
    }
  ]
}
